import { useEffect } from "react";

const BASE_TITLE = "Avahana";

/**
 * Sets the browser tab title for the current view ("Projects · Avahana").
 * Pass undefined while data is loading — the base title is used until the
 * real name arrives, and restored when the view unmounts.
 */
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} · ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
